import { Button } from "@/components/ui/button";
import { QrCode, CheckCircle2 } from "lucide-react";
import { TableDataProps } from "@/pages/SalesList";
import { SALE_STEPS, PIX_STATUS, PAYMENT_FORMS } from "@/utils/constants";

interface PixButtonProps {
  sale: TableDataProps;
  onClick: (e: React.MouseEvent, sale: TableDataProps) => void;
}

export function PixButton({ sale, onClick }: PixButtonProps) {
  const pixTransactions = sale?.transactions?.filter(t => t?.pix_copy_and_paste) || [];
  const hasPixTransaction = pixTransactions.length > 0;

  const hasPixPaymentForm = sale.payment_forms?.some(
    (form) =>
      form.payment_form.id === PAYMENT_FORMS.PIX ||
      form.payment_form.id === PAYMENT_FORMS.PIX_BTG
  );

  const paidTransactions = pixTransactions.filter(t => t?.status === PIX_STATUS.PAID);
  const allPaid = pixTransactions.length > 0 && paidTransactions.length === pixTransactions.length;
  const hasPaidPix = paidTransactions.length > 0;

  const isWaitingPayment = sale.process_step_sales?.some(
    (step) =>
      step.sale_step_id === SALE_STEPS.WAITING_PAYMENT &&
      step.process_status_id !== 3
  );

  const hasPendingPix = pixTransactions.some(t => t?.status !== PIX_STATUS.PAID);

  if (!hasPixTransaction && !hasPixPaymentForm) {
    return null;
  }

  if (hasPixTransaction && !isWaitingPayment && !hasPaidPix && !hasPendingPix) {
    return null;
  }

  const getButtonText = () => {
    if (!hasPixTransaction && hasPixPaymentForm) {
      return "PIX";
    }
    if (allPaid) {
      return "Pago";
    } else if (hasPaidPix) {
      return `${paidTransactions.length}/${pixTransactions.length} Pago`;
    } else {
      return pixTransactions.length > 1 ? `PIX (${pixTransactions.length})` : "PIX";
    }
  };

  return (
    <Button
      variant="outline"
      size="sm"
      className={`h-7 px-2 text-xs ${
        allPaid
          ? "bg-green-50 hover:bg-green-100 text-green-600"
          : hasPaidPix
          ? "bg-yellow-50 hover:bg-yellow-100 text-yellow-600"
          : "bg-blue-50 hover:bg-blue-100 text-blue-600"
      }`}
      onClick={(e) => onClick(e, sale)}
    >
      {allPaid ? (
        <>
          <CheckCircle2 className="w-3 h-3 mr-1" />
          {getButtonText()}
        </>
      ) : (
        <>
          <QrCode className="w-3 h-3 mr-1" />
          {getButtonText()}
        </>
      )}
    </Button>
  );
}
